<div class="selected-template">
  <span class="template-title">
    {{ selectedTemplateTitle }}
  </span>
  <span *ngIf="!isUKFeaturesEnabled">
    <button mat-flat-button color="primary" class="change-template-btn" (click)="openTemplates()" l10nTranslate>
      template.changeTemplate
    </button>
  </span>
</div>
<div class="compareview-heading">
  <h3 class="print-hidden">
    {{ ('user.' + reportData.entity | xTranslate) + ' ' + ('reports.compareViewList' | xTranslate) }}
  </h3>
  <span class="print-hidden">{{ recordList?.length }} {{ 'reports.compareViewRecords' | xTranslate }}</span>
</div>
<div class="divider"></div>
